import { findEntryPointDefinition } from "../../../internal/revamp/graphql/documentUtils/entrypoint";
import { compositionFragmentConfigSymbol } from "../../../internal/revamp/graphql/types/composition";
import { __passedThroughComposition } from "../../../internal/revamp/graphql/types/rootQuery";
import addTypename from "../../../internal/revamp/queryUtils/addTypename";
import { generateHashForDocument } from "../../../internal/revamp/queryUtils/documentHashing";
import { prefixVariables } from "../../../internal/revamp/queryUtils/prefixes";
import { skip } from "../../../internal/shared/utils/skip";
function isCompositionOptionsMap(options) {
    if (typeof options !== 'object' || options === null || Object.keys(options).length === 0) {
        return false;
    }
    return Object.keys(options).every((key)=>key.startsWith('S') && !isNaN(Number(key.slice(1))) || key === 'self');
}
function isLeafOptions(_document, options) {
    return options === skip || options && 'variables' in options;
}
export default function composeOptions(document, options) {
    var _findEntryPointDefinition_name, _findEntryPointDefinition;
    const documentWithTypename = addTypename(document);
    if (isCompositionOptionsMap(options)) {
        return composeOptionsForNonLeaf(documentWithTypename, options);
    }
    if (isLeafOptions(document, options)) {
        return createLeafOptions(documentWithTypename, options);
    }
    if (typeof options === 'object' && options !== null && Object.keys(options).length === 0) {
        return {
            variables: {},
            expectedErrors: {},
            skip: {},
            [__passedThroughComposition]: undefined
        };
    }
    const operationName = (_findEntryPointDefinition = findEntryPointDefinition(documentWithTypename)) === null || _findEntryPointDefinition === void 0 ? void 0 : (_findEntryPointDefinition_name = _findEntryPointDefinition.name) === null || _findEntryPointDefinition_name === void 0 ? void 0 : _findEntryPointDefinition_name.value;
    throw new Error(`Incorrect options passed to composeOptions for ${operationName}`);
}
function composeOptionsForNonLeaf(document, options) {
    const childVariables = {};
    const childExpectedErrors = {};
    const childSkip = {};
    const hash = generateHashForDocument(document);
    Object.entries(options).forEach(([prefix, prefixOptions])=>{
        if (prefix === 'self') {
            return;
        }
        Object.assign(childVariables, prefixVariables(prefixOptions.variables || {}, prefix));
        Object.assign(childExpectedErrors, prefixVariables(prefixOptions.expectedErrors || {}, prefix));
        Object.assign(childSkip, prefixVariables(prefixOptions.skip || {}, prefix));
    });
    const compositionOptionsFromChildren = {
        variables: prefixVariables(childVariables, hash),
        expectedErrors: prefixVariables(childExpectedErrors, hash),
        skip: prefixVariables(childSkip, hash),
        // Optimization to make TS happy while not using the document object at runtime.
        [__passedThroughComposition]: undefined
    };
    return compositionOptionsFromChildren;
}
function createLeafOptions(document, options) {
    const hash = generateHashForDocument(document);
    const isSkip = options === skip;
    return {
        variables: prefixVariables(isSkip ? {} : options.variables, hash),
        expectedErrors: {
            [hash]: isSkip ? [] : options.expectedErrors || []
        },
        skip: {
            [hash]: !!isSkip
        },
        // Optimization to make TS happy while not using the document object at runtime.
        [__passedThroughComposition]: undefined
    };
}
// Only exposed way of obtaining a BrandedCompositionFragmentConfig.
// Cannot be imported anywhere other than CompositionFragmentFiles through linting.
export const buildCompositionFragmentConfig = (fragment, options)=>{
    return [
        fragment,
        options,
        compositionFragmentConfigSymbol
    ];
};

//# sourceMappingURL=composition.js.map